import * as React from "react";
import * as _ from "underscore";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Button } from "carbon-components-react";

import DocumentUploader from "web_modules/DocumentUploader";
import { AppShape } from "@eave/shared/types/api";
import { docTypeToHumanStr, selectableDocTypes } from "../shared";

const styles = require("./docUploaderStyles.module.scss");

/* helpers */

const docTypeSelectOpts: any = _.map(selectableDocTypes, t => ({
  value: t,
  label: docTypeToHumanStr(t),
}));

interface DocUploaderProps {
  app: AppShape;
  onHide: Function;
  onSave: Function;
}

class DocUploader extends React.Component<DocUploaderProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      docType: null,
    };
  }

  onSelect(attr, e) {
    this.setState({
      ...this.state,
      [attr]: e ? e.value : null,
    });
  }

  render() {
    const { app, onHide, onSave } = this.props;
    const { docType, borrowerEntity } = this.state;

    let hideOrSave;
    if (docType) {
      hideOrSave = onSave;
    } else {
      hideOrSave = onHide;
    }

    let label;
    if (docType) {
      const t: any = _.findWhere(docTypeSelectOpts, { value: docType });
      label = t && t.label ? t.label : "document";
    } else {
      label = "document";
    }

    return (
      <Modal
        show
        animation
        keyboard={false}
        onHide={hideOrSave}
        backdrop="static"
        className={styles.uploaderModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload new docs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            placeholder="Select type"
            clearable={false}
            searchable
            value={docType}
            options={docTypeSelectOpts}
            onChange={this.onSelect.bind(this, "docType")}
          />
          <br />
          {docType && (
            <DocumentUploader
              applicationID={app.id}
              documentType={docType}
              prompt={`Drag and drop or click here to upload new ${label}s`}
              showOnlyCurrentUploadsOfType
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button kind="secondary" onClick={hideOrSave}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DocUploader;
